import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getOverallQuestion, getQueryParams } from 'global/js/helpers';
import { globalData } from 'global/js/globalData';
import * as Actions from 'containers/Home/actions';
import * as npsActions from './actions';
import Header from 'components/Header/Header';
import Navigation from 'components/Navigation/Navigation';
import Question from 'components/Question/Question';
import RadioButtonList from 'components/RadioButtonList/RadioButtonList';
import TextArea from 'components/TextArea/TextArea';
import './NPS.scss';

class NPS extends Component {
    constructor(props) {
        super(props);
    }

	/**
	 * Called when there is a change to the text area value. Handles updating
	 * the text value state.
	 *
	 * @param    comment : {String}
	 */
    handleChange = (comment) => {
        this.props.npsActions.setOverallAnswer({
            type: globalData.questionTypes.nps,
            comment: comment
        });
    }

    render() {
        const { actions, individualID, npsActions, prodTourID, surveyData } = this.props;
        const isBackupSurvey = surveyData.IsBackup || false; 
        const question = getOverallQuestion(surveyData.OverallSubmission.OverallQuestions, globalData.questionTypes.nps);
        const questionAnswer = question.Answer.AnswerRating;
        const questionComment = question.Answer.AnswerComment;
        const questionText = question.Text;
        const questionType = question.Type;
        const subText = question.SubText;

        return (
            <section className='wrapper nps'>
                {surveyData.IsBackup && (
                    <Header customerData={surveyData.Evaluator} isOverall={true} />
                )}

                <div className='container'>
                    <h1 className="stay-name">Overall <br /> Experience</h1>

                    <div className='content'>
                        <Question questionText={questionText} />
						
                        <RadioButtonList 
                            answerValue={questionAnswer} 
                            handleClick={npsActions.setOverallAnswer} 
                            questionType={questionType}
                        />

                        <Question questionText={subText} />

                        <TextArea 
                            handleChange={this.handleChange} 
                            textValue={questionComment}
                        />
        				
                        <Navigation 
                            actions={actions}
                            answerValue={questionAnswer}
                            individualID={individualID}
                            isBackupSurvey={isBackupSurvey}
                            isOverall={true}
                            locationIndex={0}
                            nextLink='/TE'
                            prevLink='/'
                            prodTourID={prodTourID}
                            surveyData={surveyData}
                        />
                    </div>
                </div>
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        individualID: state.dataReducer.individualID,
        prodTourID: state.dataReducer.prodTourID,
        surveyData: state.surveyReducer.surveyData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Actions, dispatch),
        npsActions: bindActionCreators(npsActions, dispatch)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NPS));



// WEBPACK FOOTER //
// ./application/containers/NPS/NPS.jsx